module.exports = __webpack_public_path__ + "static/media/OKB.3dde1026.svg";